export enum ChatState {
    New = "New",
    Parked = "Parked",
    TalkingToBot = "TalkingToBot",
    ParkedWithBot = "ParkedWithBot",
    TalkingToRep = "TalkingToRep",
    Closed = "Closed",
}
